import { startOfDay } from 'date-fns';

import { Calendar } from './calendar';

interface DatePickerSecondaryProps {
	selectedDate: Date | undefined;
	onSelectDate: (date: Date | undefined) => void;
}

function DatePickerSecondary({ selectedDate, onSelectDate }: DatePickerSecondaryProps) {
	return (
		<div className="p-1">
			<Calendar
				mode="single"
				captionLayout="dropdown-buttons"
				selected={selectedDate ? new Date(selectedDate) : undefined}
				onSelect={onSelectDate}
				fromYear={1960}
				toYear={2030}
				disabled={(date) => date < startOfDay(new Date())}
				defaultMonth={selectedDate ? new Date(selectedDate) : new Date()}
				initialFocus
			/>
		</div>
	);
}

export default DatePickerSecondary;
